/**
 * Created by Omar Alejandro Leonor Avalos on 2017-07-22.
 */
import React, { Component } from 'react';
import WhatShot from 'material-ui/svg-icons/social/whatshot';
import Portrait from 'material-ui/svg-icons/image/portrait';
import Work from 'material-ui/svg-icons/action/work';
import Status from 'material-ui/svg-icons/device/graphic-eq';
import Arribo from 'material-ui/svg-icons/maps/local-parking';
import Pago from 'material-ui/svg-icons/action/payment';
import Pedimento from 'material-ui/svg-icons/file/folder-open';
import Aduana from 'material-ui/svg-icons/action/home';
import Aerolinea from 'material-ui/svg-icons/device/airplanemode-active';
import Via from 'material-ui/svg-icons/maps/place';
import Tipo from 'material-ui/svg-icons/action/compare-arrows';
import Factura from 'material-ui/svg-icons/av/library-books';
import ValorAduanal from 'material-ui/svg-icons/editor/attach-money';
import Peso from 'material-ui/svg-icons/action/line-weight';
import Bultos from 'material-ui/svg-icons/image/view-compact';
import Hawb from 'material-ui/svg-icons/editor/format-list-numbered';
import Origen from 'material-ui/svg-icons/social/location-city';
import { TextField } from 'material-ui';
import Filter from './filter';
import Container from './container';
import DateRange from './dateRange';
import PatternInput from './patternInput';
import InputWithOptions from './InputWithOptions';
import { extractProperty } from '../../common/helpers';
import {
    DropDownSearch,
    RemoteDropDownSearch,
    RemoteCheckboxGroup
} from '../../components/data-containers';

const filter = {
    folio: '',
    customer: '',
    supplier: '',
    status: [],
    arrivalTimestamp: '',
    requestingPaymentTimestamp: '',
    requestingNumber: '',
    customsHouse: '',
    comertialInvoiceNumber: '',
    shippingCompany: '',
    via: [],
    originDestination: '',
    mawbMbl: '',
    hawbHbl: '',
    packages: '',
    weight: '',
    customsValue: '',
    type: []
};

const searchTexts = {
    supplierText: '',
    customerText: '',
    customsValueAux: '',
    minArrivalDate: {},
    maxArrivalDate: {},
    minRequestingDate: {},
    maxRequestingDate: {}
};

const getCustomsHouseName = (customsHouses, customsHouse) => {
    const objectValue = customsHouses.find(ch => ch.uuid === customsHouse);
    return objectValue ? objectValue.name : '';
};

class FilterContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            ...filter,
            ...searchTexts
        };
    }

    updateValue = (path, value) => {
        this.setState({ [path]: value });
    };

    render() {
        const { children, onSearch, onClear, customsHouses = [] } = this.props;
        const { status, via, type, folio, customsHouse, customsValueAux, supplierText, customerText, requestingNumber, comertialInvoiceNumber, shippingCompany, originDestination,
            mawbMbl, hawbHbl, weight, packages, minArrivalDate, maxArrivalDate, minRequestingDate, maxRequestingDate } = this.state;

        return (
            <Container
                contents={children}
                onSearch={() => onSearch(this.state)}
                onClear={() => {
                    this.setState({ ...filter, ...searchTexts })
                    onClear(this.state);
                }}
            >
                <Filter icon={<WhatShot />} title="Folio" id="noDespacho">
                    <TextField
                        hintText="AFSI..."
                        fullWidth
                        value={folio}
                        onChange={(event, value) => this.updateValue('folio', value)}
                    />
                </Filter>

                <Filter icon={<Portrait />} title="Cliente" id="cliente">
                    <RemoteDropDownSearch
                        onChange={(selectedValue) => {
                            this.updateValue('customer', selectedValue.id);
                            this.updateValue('customerText', selectedValue.name);
                        }}
                        searchText={customerText}
                        dataSourceConfig={{ text: 'name', value: 'id' }}
                        entity='customers'
                        serviceName='customers'
                        url='/customers/search/findTop10ByNameIgnoreCaseContaining'
                        projectionName='forListing'
                    />
                </Filter>

                <Filter icon={<Work />} title="Proveedor" id="proveedor">
                    <RemoteDropDownSearch
                        onChange={(selectedValue) => {
                            this.updateValue('supplier', selectedValue.id);
                            this.updateValue('supplierText', selectedValue.name);
                        }}
                        searchText={supplierText}
                        dataSourceConfig={{ text: 'name', value: 'id' }}
                        entity='suppliers'
                        serviceName='suppliers'
                        url='/suppliers/search/findTop10ByNameIgnoreCaseContaining'
                        projectionName='forListing'
                    />
                </Filter>

                <Filter icon={<Status />} title="Status" id="status" count={status.length}>
                    <RemoteCheckboxGroup
                        selectedValues={status}
                        dataType={RemoteCheckboxGroup.TYPES.STATUSES}
                        displayProp={(item) => item.representation}
                        valueProp="representation"
                        notify={(checkedValues) =>
                            this.updateValue('status', checkedValues)
                        }
                    />
                </Filter>

                <Filter icon={<Arribo />} title="Arribo" id="arribo">
                    <DateRange
                        notify={(start, end, date1, date2) => {
                            this.updateValue('arrivalTimestamp', `${start},${end}`);
                            this.updateValue('minArrivalDate', date1);
                            this.updateValue('maxArrivalDate', date2);
                        }}
                        searchTexts={minArrivalDate}
                        searchTexts2={maxArrivalDate}
                    />
                </Filter>

                <Filter icon={<Pago />} title="Pago Pedimento" id="pagoPedimento">
                    <DateRange
                        notify={(start, end, date1, date2) => {
                            this.updateValue('requestingPaymentTimestamp', `${start},${end}`);
                            this.updateValue('minRequestingDate', date1);
                            this.updateValue('maxRequestingDate', date2);
                        }}
                        searchTexts={minRequestingDate}
                        searchTexts2={maxRequestingDate}
                    />
                </Filter>

                <Filter icon={<Pedimento />} title="Pedimento" id="pedimento">
                    <TextField
                        fullWidth
                        hintText="00000"
                        value={requestingNumber}
                        onChange={(event, value) => this.updateValue('requestingNumber', value)}
                    />
                </Filter>

                <Filter icon={<Aduana />} title="Aduana" id="aduana">
                    <DropDownSearch
                        fullWidth
                        searchText={getCustomsHouseName(customsHouses, customsHouse)}
                        dataSource={extractProperty(customsHouses, 'name')}
                        onNewRequest={(request, idx) => {
                            //id = name
                            const newValue = customsHouses[idx].uuid;
                            this.updateValue('customsHouse', newValue);
                        }}
                    />
                </Filter>

                <Filter icon={<Factura />} title="Factura" id="factura">
                    <TextField
                        hintText="0000"
                        fullWidth
                        value={comertialInvoiceNumber}
                        onChange={(event, value) =>
                            this.updateValue('comertialInvoiceNumber', value)
                        }
                    />
                </Filter>

                <Filter icon={<Aerolinea />} title="Aerolinea / Naviera / Carrier" id="aerolinea">
                    <TextField
                        hintText="Ferromex"
                        fullWidth
                        value={shippingCompany}
                        onChange={(event, value) =>
                            this.updateValue('shippingCompany', value)
                        }
                    />
                </Filter>

                <Filter icon={<Via />} title="Via" id="via" count={via.length}>
                    <RemoteCheckboxGroup
                        selectedValues={via}
                        dataType={RemoteCheckboxGroup.TYPES.VIAS}
                        displayProp={(item) => item.name}
                        valueProp="name"
                        notify={(checkedValues) =>
                            this.updateValue('via', checkedValues)
                        }
                    />
                </Filter>

                <Filter icon={<Origen />} title="Origen" id="origen">
                    <TextField
                        hintText="China"
                        fullWidth
                        value={originDestination}
                        onChange={(event, value) => this.updateValue('originDestination', value)}
                    />
                </Filter>

                <Filter icon={<Hawb />} title="MAWB/MBL" id="mawbmbl">
                    <TextField
                        type="number"
                        hintText="000"
                        fullWidth
                        value={mawbMbl}
                        onChange={(event, value) => this.updateValue('mawbMbl', value)}
                    />
                </Filter>

                <Filter icon={<Hawb />} title="HAWB/HBL" id="hawbhbl">
                    <TextField
                        type="number"
                        hintText="000"
                        fullWidth
                        value={hawbHbl}
                        onChange={(event, value) => this.updateValue('hawbHbl', value)}
                    />
                </Filter>

                <Filter icon={<Bultos />} title="Bultos" id="bultos">
                    <PatternInput
                        pattern="[0-9] [a-zA-Z]"
                        hintText="12 bultos"
                        errorText="Debe ingresar un numero seguido de un espacio y texto"
                        notify={(value) => this.updateValue('packages', value)}
                        searchTexts={packages}
                    />
                </Filter>

                <Filter icon={<Peso />} title="Peso" id="peso">
                    <TextField
                        type="number"
                        hintText="Kg"
                        fullWidth
                        value={weight}
                        onChange={(event, value) => this.updateValue('weight', value)}
                    />
                </Filter>

                {/*<Filter icon={<ValorAduanal />} title="Valor Aduanal" id="valoraduanal">
                    <InputWithOptions
                        options={[
                            { id: '1', name: 'Igual a' },
                            { id: '2', name: 'Mayor que' },
                            { id: '3', name: 'Menor que' }
                        ]}
                        selectLabel="Operación"
                        inputLabel="Valor"
                        hintText="00000"
                        notify={(option, value) => {
                            if (value !== '') {
                                this.updateValue('customsValue', `${option.name},${value}`);
                                this.updateValue('customsValueAux', `${value}`);
                            } else {
                                this.updateValue('customsValue', '');
                                this.updateValue('customsValueAux', '');
                            }
                        }}
                        searchTexts={customsValueAux}
                    />
                </Filter>*/}

                <Filter icon={<Tipo />} title="Tipo" id="tipo" count={type.length}>
                    <RemoteCheckboxGroup
                        selectedValues={type}
                        dataType={RemoteCheckboxGroup.TYPES.IMPORT_EXPORT}
                        displayProp={(item) => item.name}
                        valueProp="id"
                        notify={(checkedValues) =>
                            this.updateValue('type', checkedValues)
                        }
                    />
                </Filter>

            </Container>
        );
    }
}

export default FilterContainer;



// WEBPACK FOOTER //
// ./components/filters/despachos.js